import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { testHtmlRegex } from '../../helpers/helpers';


@Component({
  selector: 'app-form-fields-wrapper',
  templateUrl: './form-fields-wrapper.component.html',
  styleUrls: ['./form-fields-wrapper.component.scss']
})
export class FormFieldsWrapperComponent extends FieldWrapper implements OnInit {
  isHtml : boolean = false;
  ngOnInit(): void {
    this.isHtml = testHtmlRegex(this.props.description);
  }

}
